import React from "react";
import ActionTabs from '../../../accessGlobalComponents/ActionTabs';
import { UserTypeEnum } from '../../../../../models/User'
import { connect } from "react-redux";
import { IAppState } from '../../../../../redux/storeTypes';
import _ from "lodash";


const InternalUsers = ({ role, modulePermissions }: any) => {

    if (modulePermissions) {

        const roleArrays = role?.roleModulePermissions?.map((fields: any) => fields?.modulePermission)

        const reformatedArray = _.isEmpty(roleArrays)
            ?
            modulePermissions.map((fields: any) => ({ ...fields, selected: false }))
            :
            modulePermissions.map((basePermissions: any) => ({
                ...basePermissions,
                selected: roleArrays.some((selectedPermissions: any) => selectedPermissions.description === basePermissions.description && selectedPermissions.crudPermission === basePermissions.crudPermission),
            }))

        const InternalPermissions = _.groupBy(reformatedArray.filter((permissions: any) => permissions.tag === 'Internal User Management'), 'description')

        return (
            <>
                <div className="roleGrids">
                    {Object.entries(InternalPermissions).map(
                        ([index, value]: any) => {
                            return (
                                <div key={index}>
                                    <h3>{index}</h3>
                                    <ActionTabs {...role} crudPermissions={value} roleType={UserTypeEnum.Navient} />
                                </div>
                            )
                        }
                    )}
                </div>
            </>
        );
    }
    else {
        return (
            <></>
        )
    }
};

const mapStateToProps = (state: IAppState) => {
    return {
        role: state.roles.role,
        modulePermissions: state.roles.modulePermissions
    };
};

export default connect(mapStateToProps)(InternalUsers);